export interface GeoCoordinates {
  latitude: number
  longitude: number
}

const EARTH_RADIUS_KM = 6371

export function parseGeoCoordinate(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function isValidGeoCoordinates(
  latitude: number | string | null | undefined,
  longitude: number | string | null | undefined,
): boolean {
  const lat = parseGeoCoordinate(latitude)
  const lon = parseGeoCoordinate(longitude)
  if (lat === null || lon === null) return false
  return lat !== 0 || lon !== 0
}

export function toGeoCoordinates(
  latitude: number | string | null | undefined,
  longitude: number | string | null | undefined,
): GeoCoordinates | null {
  const lat = parseGeoCoordinate(latitude)
  const lon = parseGeoCoordinate(longitude)
  if (lat === null || lon === null) return null
  if (lat === 0 && lon === 0) return null
  return { latitude: lat, longitude: lon }
}

/** Distancia en km entre dos puntos (fórmula de Haversine). */
export function haversineDistanceKm(
  from: GeoCoordinates,
  to: GeoCoordinates,
): number {
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180
  const dLat = toRadians(to.latitude - from.latitude)
  const dLon = toRadians(to.longitude - from.longitude)
  const lat1 = toRadians(from.latitude)
  const lat2 = toRadians(to.latitude)

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2

  return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}
